import script from "./Template-000.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template-000.vue?vue&type=script&lang=ts&setup=true"

import "./Template-000.vue?vue&type=style&index=0&id=536cda71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536cda71"]])

export default __exports__